import { useContext } from 'react';
import { DevExtremeContext } from '@core/components';

export const useScreenSize = () => {
  const { screenSize } = useContext(DevExtremeContext);

  return screenSize;
};
